import type { SupplierForm } from '@klear/supplier/wire.client'
import type { SupplierFormDirty } from '@klear/supplier/wire.client'
import { createEntityFormStateHelpers, type EntityFormErrorMap } from '@klear/ui/entity-form-state'

type SupplierAddressForm = SupplierForm['address']
type SupplierTopLevelField = Extract<Exclude<keyof SupplierForm, 'address'>, string>
type SupplierAddressField = Extract<keyof SupplierAddressForm, string>

export type SupplierFormFieldPath = SupplierTopLevelField | `address.${SupplierAddressField}`
export type SupplierFormFieldValue = SupplierForm[SupplierTopLevelField] | SupplierAddressForm[SupplierAddressField]

const helpers = createEntityFormStateHelpers<SupplierForm, SupplierFormDirty>()

export const markSupplierFormDirtyPaths = helpers.markDirtyPaths as (
  draft: Parameters<typeof helpers.markDirtyPaths>[0],
  paths: SupplierFormFieldPath | readonly SupplierFormFieldPath[]
) => void

export const setSupplierFormField = helpers.setField as (
  draft: Parameters<typeof helpers.setField>[0],
  path: SupplierFormFieldPath,
  value: SupplierFormFieldValue
) => void

export const clearSupplierFormErrors = helpers.clearErrors as (
  errors: EntityFormErrorMap,
  paths: SupplierFormFieldPath | readonly SupplierFormFieldPath[]
) => EntityFormErrorMap
